import { api } from '@/scripts/api'

const URL = '/ms/socialmedia/v1'
const COMMENT = 'socialcomment'
const PRIVATE_MESSAGE = 'privatemessage'

export const SocialMediaPostConversationsService = {
    fetchTotalUnreadComments(clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/count/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    fetchTotalUnreadPrivateMessages(clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${PRIVATE_MESSAGE}/count/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    getAllComments(clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    getComment(commentId, clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/${commentId}/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    deleteComment(socialNetwork, commentId, clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/${socialNetwork}/${commentId}/${clientId}`

            api.delete(service)
                .then(resolve)
                .catch(reject)
        })
    },

    toggleCommentsStatus(clientId, params) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/status/${clientId}`

            api.put(service, params)
                .then(resolve)
                .catch(reject)
        })
    },

    postComment(clientId, socialNetwork, params) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${COMMENT}/${socialNetwork}/${clientId}`

            api.post(service, params)
                .then(resolve)
                .catch(reject)
        })
    },

    getAllPrivateMessages(clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${PRIVATE_MESSAGE}/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    togglePrivateMessageStatus(clientId, params) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${PRIVATE_MESSAGE}/close/${clientId}`

            api.put(service, params)
                .then(resolve)
                .catch(reject)
        })
    },

    getPrivateMessage(messageId, clientId) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${PRIVATE_MESSAGE}/${messageId}/${clientId}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    postPrivateMessage(clientId, socialNetwork, params) {
        return new Promise((resolve, reject) => {
            const service = `${URL}/${PRIVATE_MESSAGE}/${socialNetwork}/${clientId}`

            api.post(service, params)
                .then(resolve)
                .catch(reject)
        })
    },
}
